export default __webpack_public_path__ + "static/media/logout.90cb8877.svg";